<template>
  <div class="register">
    <div class="header">
      <img style="width: 0.52rem" :src="backImg" alt="" @click="clickLeft" />
      <div class="text">{{ loginTitle }}</div>
    </div>
    <div class="content">
      <div class="register-login">
        <div class="tabs" v-if="flag !== 3">
          <div @click="changeTab(1)" class="tabs-box tabs1" :class="{ active: flag == 1 }">
            {{ $t("rigisterPage.tab1") }}
          </div>
          <div @click="changeTab(2)" class="tabs-box tabs2" :class="{ active: flag == 2 }">
            {{ $t("rigisterPage.tab2") }}
          </div>
        </div>
        <div class="form-content">
          <div class="form-sty" v-if="flag === 1">
            <form>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.email") }}</label>
                <van-field v-model="registerForm.userName" :border="false" @blur="checkRegisted" />
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.yanzhengma") }}</label>
                <van-field v-model="registerForm.verifyCode" :border="false">
                  <button slot="button" @click.prevent="getVerifyCode(1)" :disabled="!canClick" class="verifyCodeBtn">
                    {{
                      canClick ? $t("rigisterPage.form.getYanzhengma") : content
                    }}
                  </button>
                </van-field>
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.pwd") }}</label>
                <van-field v-model="registerForm.password" :type="regPwdCanSee ? 'text' : 'password'" clearable
                  :border="false">
                  <span slot="button">
                    <van-icon :name="regPwdCanSee ? 'eye-o' : 'closed-eye'" @click="regPwdCanSee = !regPwdCanSee" />
                  </span>
                </van-field>
              </div>
              <div class="intensity">
                <div class="title">{{ $t("intensity") }}</div>
                <div class="box"></div>
                <div class="box"></div>
                <div class="box"></div>
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.rePwd") }}</label>
                <van-field v-model="registerForm.confirmedPassword" :type="regRePwdCanSee ? 'text' : 'password'" clearable
                  :border="false">
                  <span slot="button">
                    <van-icon :name="regRePwdCanSee ? 'eye-o' : 'closed-eye'" @click="regRePwdCanSee = !regRePwdCanSee" />
                  </span>
                </van-field>
              </div>
            </form>
          </div>

          <div class="form-sty" v-if="flag === 2">
            <form>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.lAccount") }}</label>
                <van-field v-model="loginForm.userName" :border="false" />
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.lPwd") }}</label>
                <van-field v-model="loginForm.password" clearable :border="false" :type="pwdCanSee ? 'text' : 'password'">
                  <span slot="button">
                    <van-icon :name="pwdCanSee ? 'eye-o' : 'closed-eye'" @click="viewPwd" />
                  </span>
                </van-field>
              </div>
              <div class="forget-psw" @click="forgetPwd">
                {{ $t("rigisterPage.form.forgetPwd") }}?
              </div>
            </form>
          </div>

          <div class="form-sty" v-if="flag === 3">
            <form>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.email") }}</label>
                <van-field v-model="registerForm.userName" :border="false" />
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.yanzhengma") }}</label>
                <van-field v-model="registerForm.verifyCode" :border="false">
                  <button slot="button" @click.prevent="getVerifyCode(2)" :disabled="!canClick" class="verifyCodeBtn">
                    {{
                      canClick ? $t("rigisterPage.form.getYanzhengma") : content
                    }}
                  </button>
                </van-field>
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.pwd") }}</label>
                <van-field v-model="registerForm.password" :type="regPwdCanSee2 ? 'text' : 'password'" clearable
                  :border="false">
                  <span slot="button">
                    <van-icon :name="regPwdCanSee2 ? 'eye-o' : 'closed-eye'" @click="regPwdCanSee2 = !regPwdCanSee2" />
                  </span>
                </van-field>
              </div>
              <div class="form-wrap">
                <label>{{ $t("rigisterPage.form.rePwd") }}</label>
                <van-field v-model="registerForm.confirmedPassword" :type="regRePwdCanSee2 ? 'text' : 'password'"
                  clearable :border="false">
                  <span slot="button">
                    <van-icon :name="regRePwdCanSee2 ? 'eye-o' : 'closed-eye'"
                      @click="regRePwdCanSee2 = !regRePwdCanSee2" />
                  </span>
                </van-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-if="flag === 3" style="padding: 10px 15px; line-height: 20px; color: #c75353">
        <span>{{ $t("rigisterPage.form.tip") }}</span>
      </div>

      <div class="xieyi-content" v-if="flag === 1">
        <van-button round block type="info" @click="onSubmit">{{
          $t("rigisterPage.form.regBtn")
        }}</van-button>
      </div>
      <div v-if="flag === 1" class="xieyi">
        {{ $t("rigisterPage.form.bottomText")
        }}
        <span @click="huiyuanxieyi">{{ $t("rigisterPage.form.huiyuanxieyi") }}</span> & <span @click="yinsitiaokuan">{{
          $t("rigisterPage.form.yinsitiaokuan") }}</span>
      </div>
      <div class="xieyi-content" v-if="flag === 2">
        <van-button round block type="info" @click="login">{{
          $t("rigisterPage.form.loginBtn")
        }}</van-button>
      </div>
      <div class="xieyi-content" v-if="flag === 3">
        <van-button round block type="info" @click="resetAccount">{{
          $t("rigisterPage.form.reset")
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import backPng from "@/assets/img/back.png";
import {
  login as authLogin,
  registryCode,
  registered,
  registry,
  forgotPasswordCode,
  forgotPassword,
  accounts,
} from "@/api/api.js";
import { Notify } from "vant";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      backImg: backPng,
      loginTitle: "",
      registerForm: {
        userName: "",
        verifyCode: "",
        password: "",
        confirmedPassword: "",
        recommendedCode: "",
        channelCode: "",
        keyOfChannel: "",
        deviceID: "",
        deviceType: "",
        fingerprintCode: "",
      },
      verifyCodeTag: false,
      loginForm: {
        userName: "",
        password: "",
      },
      flag: 1,
      pwdCanSee: false,
      regPwdCanSee: false,
      regRePwdCanSee: false,
      regPwdCanSee2: false,
      regRePwdCanSee2: false,

      content: this.$t("rigisterPage.form.getYanzhengma"), // 按钮里显示的内容
      totalTime: 60, // 记录具体倒计时时间
      canClick: true, // 添加canClick
      clock: null,
    };
  },
  watch: {
    "registerForm.password"(newValue, oldValue) {
      console.log(typeof newValue, oldValue);
      let show = [];
      let test1 = /\d/; //判断数字
      let test2 = /[A-Z]/; //判断大写字母
      let test3 = /[a-z]/; //判断小写字母
      if (test1.test(newValue)) {
        show.push("1");
      }
      if (test2.test(newValue)) {
        show.push("1");
      }
      if (test3.test(newValue)) {
        show.push("1");
      }
      for (let i = 0; i < 3; i++) {
        if (show[i]) {
          document.getElementsByClassName("box")[i].className = "box red";
        } else {
          document.getElementsByClassName("box")[i].className = "box";
        }
      }
    },
  },
  computed: {},
  created() {
    //从路由对象里面取出url携带的参数并存储本地
    let query = this.$route.query;
    if (query.uid || query.channel || query.cid) {
      let params = {
        recommendedCode: query.uid || "",
        channelCode: query.cid || "",
        keyOfChannel: query.cuid || "",
      };
      window.sessionStorage.setItem("recommendedInfo", JSON.stringify(params));
    }
  },
  methods: {
    async checkRegisted() {
      if (!this.registerForm.userName) {
        Notify({ type: "warning", message: this.$t("inputEmail") });
        return;
      } else {
        let params = { userName: this.registerForm.userName };
        await registered(params).then((res) => {
          if (res.code !== 200) {
            Notify({ type: "warning", message: res.errors[0] });
          }
        });
      }
    },

    setTime() {
      if (!this.canClick) return; // 如果是false 直接return出去
      this.canClick = false;
      //if (this.$i18n.locale === "en") {
      //  this.content = "Resend after " + this.totalTime + "s";
      //} else {
      //  this.content = this.totalTime + "s 后重新发送";
      //}
      this.content = this.$t("rigisterPage.timeTick").replace(
        "{0}",
        this.totalTime
      );

      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.$t("rigisterPage.timeTick").replace(
          "{0}",
          this.totalTime
        );
        //if (this.$i18n.locale === "en") {
        //  this.content = "Resend after" + this.totalTime + "s";
        //} else {
        //  this.content = this.totalTime + "s 后重新发送";
        //}
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.content = this.$t("sendVerfAgain");
          this.totalTime = 60;
          this.canClick = true; // 这里重新开启
        }
      }, 1000);
    },

    viewPwd() {
      this.pwdCanSee = !this.pwdCanSee;
    },

    clickLeft() {
      if (this.flag === 1 || this.flag === 2) {
        this.$router.go(-1);
      } else {
        this.flag = 2;
        this.loginTitle = this.$t("rigisterPage.tab2");
        this.resetLoginForm();
      }
    },
    // 获取验证码
    async getVerifyCode(flag) {
      if (!this.registerForm.userName) {
        Notify({ type: "warning", message: this.$t("inputEmail") });
        return;
      }

      this.setTime();
      let params = {
        userName: this.registerForm.userName,
        challenge: "",
        validate: "",
        seccode: "",
      };

      if (flag === 1) {
        registryCode(params).then((res) => {
          if (res.code === 200) {
            this.verifyCodeTag = true;
            Notify({ type: "primary", message: this.$t("alreadySend") });
          } else {
            window.clearInterval(this.clock);
            this.totalTime = 60;
            this.canClick = true;
            this.verifyCodeTag = false;
            Notify({ type: "warning", message: res.errors[0] });
          }
        });
      } else {
        forgotPasswordCode(params).then((res) => {
          if (res.code === 200) {
            this.verifyCodeTag = true;
            Notify({ type: "primary", message: this.$t("alreadySend") });
          } else {
            window.clearInterval(this.clock);
            this.totalTime = 60;
            this.canClick = true;
            this.verifyCodeTag = false;
            Notify({ type: "warning", message: res.errors[0] });
          }
        });
      }
    },

    // 提交注册
    async onSubmit() {
      //获取本地存储的推荐人信息
      let recommendedInfo = window.sessionStorage.getItem("recommendedInfo");
      if (recommendedInfo !== null) {
        recommendedInfo = JSON.parse(recommendedInfo);
        Object.assign(this.registerForm, recommendedInfo);
      }
      console.log(1234, this.registerForm.password);
      if (document.getElementsByClassName('box red').length < 2) {
        Notify({
          type: "warning",
          message: this.$t("rigisterPage.intensity"),
        });
        return
      }
      await registry(this.registerForm).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.registerSuccessed"),
          });
          setTimeout(() => {
            this.flag = 2;
          }, 1000);
        } else {
          Notify({ type: "primary", message: res.errors[0] });
        }
      });
    },
    // 登录
    async login() {
      let params = this.loginForm;
      await authLogin(params).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.loginSuccessed"),
          });
          localStorage.setItem("LOGIN_INFO", JSON.stringify(res.data));
          this.getAccountInfo(res.data.id);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    async getAccountInfo(id) {
      await accounts({ id }).then((res) => {
        if (res.code === 200) {
          if (res.data.isBlacklist) {
            this.$router.push("/mine");
          } else {
            this.$router.push("/questionnaire");
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    // 重置密码
    resetAccount() {
      let { userName, verifyCode, password, confirmedPassword } =
        this.registerForm;
      let params = {
        userName,
        verificationCode: verifyCode,
        newPassword: password,
        confirmedPassword,
      };
      forgotPassword(params).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.changePasswordSuccessed"),
          });
          this.flag = 2;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    changeTab(flag) {
      this.flag = flag;
      if (this.flag === 1) {
        this.loginTitle = this.$t("rigisterPage.title1");
      } else if (this.flag === 2) {
        this.loginTitle = this.$t("rigisterPage.title2");
      }
    },

    // 忘记密码
    forgetPwd() {
      this.flag = 3;
      this.loginTitle = this.$t("rigisterPage.title3");
      this.resetLoginForm();
    },

    resetLoginForm() {
      this.registerForm.userName = "";
      this.registerForm.verifyCode = "";
      this.registerForm.password = "";
      this.registerForm.confirmedPassword = "";
    },

    // 跳转协议
    yinsitiaokuan() {
      this.$router.push("/privacyClauses/2");
    },

    huiyuanxieyi() {
      this.$router.push("/privacyClauses/1");
    },

  },
  mounted() {
    this.$nextTick(() => {
      this.loginTitle = this.$t("rigisterPage.title1");
    });
  },
  activated() { },
};
</script>

<style lang="stylus" scoped>
/deep/.register {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: url('../../assets/img/登录新.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .header {
    width: 100%;
    padding: 0.2rem;

    .text {
      margin-top: 0.2rem;
      margin-left: 0.8rem;
      font-size: 0.5rem;
      color: white;
    }
  }

  .content {
    padding-left: 10%;
    width: 80%;
    margin-top: 100px;

    .register-login {
      background-color: white;
      border-radius: 18px;
      box-shadow: 0 0 0.08rem 0.04rem rgba(0, 0, 0, 0.03);

      .tabs {
        width: 100%;
        height: 0.72rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 0.15rem;

        div {
          width: 50%;
          border-bottom: 1px solid #EAE9E9;
          text-align: center;
          line-height: 0.72rem;
          background: #EAE9E9;
          color: #101010;
          font-size: 0.3rem;
        }

        .tabs1 {
          border-radius: 18px 0 0 0;
        }

        .tabs2 {
          border-radius: 0 18px 0 0;
        }
      }

      .form-content {
        padding-bottom: 0.2rem;

        .form-sty {
          position: relative;

          .form-wrap {
            position: relative;

            .verifyCodeBtn {
              display: inline-block;
              color: #0094DE;
              background: none;
            }

            .register-input {
              border: none !important;
              border-bottom: 0.01rem solid #101010 !important;
              border-radius: 0 !important;
            }
          }

          form {
            padding-top: 20px;

            label {
              margin-left: 0.32rem;
              display: block;
            }

            input[type=text], input[type=password], select {
              width: 90%;
              height: 0.6rem;
              display: inline-block;
              border-radius: 4px;
              box-sizing: border-box;
            }

            .forget-psw {
              margin-left: 0.5rem;
              color: orange;
            }
          }
        }
      }
    }

    .xieyi-content {
      margin: 0.3rem 0.6rem;

      button {
        background: #0056B5;
        border: 1px solid #0056B5;
      }
    }

    .xieyi {
      text-align: center;
      margin-top: 0.4rem;
      font-weight: 600;

      span {
        color: #FE7932;
        cursor: pointer;
      }
    }
  }
}

.active {
  background: #ffffff !important;
}

.absoluteIcon {
  position: absolute;
  bottom: 0.6rem;
  right: 0.4rem;
}

/deep/ .van-button__text {
  font-size: 0.3rem;
  font-weight: 500;
}

/deep/ .van-cell {
  padding-top: 0;
  padding-bottom: 12px;
}

/deep/ .van-cell__value {
  border-bottom: 1px solid #101010;
}
</style>
<style scoped>
.intensity {
  width: 100%;
  height: 30px;
  margin-bottom: 15px;
  /* background-color: blue; */
  display: flex;
  align-items: center;
}

.title {
  margin-left: 15px;
  margin-right: 10px;
}

.intensity>.box {
  width: 30px;
  height: 10px;
  background-color: rgb(232, 220, 220);
  margin-left: 5px;
}

.intensity>.red {
  background-color: green;
}
</style>


// WEBPACK FOOTER //
// src/pages/register/Register.vue